export interface ReportPeriod {
  end: string;
  start: string;
}

function dateAtNoon(value: string): Date {
  return new Date(`${value}T12:00:00.000Z`);
}

function isoDate(value: Date): string {
  return value.toISOString().slice(0, 10);
}

export function todayIn(timezone: string, now = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    day: "2-digit",
    month: "2-digit",
    timeZone: timezone,
    year: "numeric",
  }).format(now);
}

export function reportPeriodPreset(
  preset: "current_year" | "last_twelve_months" | "previous_year",
  today: string,
): ReportPeriod {
  const year = Number(today.slice(0, 4));
  if (preset === "current_year") return { end: today, start: `${year}-01-01` };
  if (preset === "previous_year")
    return { end: `${year - 1}-12-31`, start: `${year - 1}-01-01` };
  const start = dateAtNoon(today);
  start.setUTCFullYear(start.getUTCFullYear() - 1);
  start.setUTCDate(start.getUTCDate() + 1);
  return { end: today, start: isoDate(start) };
}

// "Since last verification": from the latest visit (Location.last_verified_on)
// to today. Null when there is no visit yet, or it is in the future.
export function sinceLastVerification(
  lastVerifiedOn: string | null | undefined,
  today: string,
): ReportPeriod | null {
  if (!lastVerifiedOn || !/^\d{4}-\d{2}-\d{2}$/.test(lastVerifiedOn))
    return null;
  return lastVerifiedOn <= today ? { end: today, start: lastVerifiedOn } : null;
}

export function validReportPeriod(period: ReportPeriod): boolean {
  return (
    /^\d{4}-\d{2}-\d{2}$/.test(period.start) &&
    /^\d{4}-\d{2}-\d{2}$/.test(period.end) &&
    period.start <= period.end
  );
}
